__turbopack_context__.v({
  "author": "Testimonials-module__7XlpBa__author",
  "description": "Testimonials-module__7XlpBa__description",
  "headline": "Testimonials-module__7XlpBa__headline",
  "image": "Testimonials-module__7XlpBa__image",
  "imageNext": "Testimonials-module__7XlpBa__imageNext",
  "imageNext2": "Testimonials-module__7XlpBa__imageNext2",
  "imagePrevious": "Testimonials-module__7XlpBa__imagePrevious",
  "imageSelected": "Testimonials-module__7XlpBa__imageSelected",
  "imagesWrapper": "Testimonials-module__7XlpBa__imagesWrapper",
  "next": "Testimonials-module__7XlpBa__next",
  "next2": "Testimonials-module__7XlpBa__next2",
  "nextButton": "Testimonials-module__7XlpBa__nextButton",
  "previous": "Testimonials-module__7XlpBa__previous",
  "root": "Testimonials-module__7XlpBa__root",
  "selected": "Testimonials-module__7XlpBa__selected",
  "stars": "Testimonials-module__7XlpBa__stars",
  "testimonial": "Testimonials-module__7XlpBa__testimonial",
  "testimonialSelected": "Testimonials-module__7XlpBa__testimonialSelected",
  "testimonialsWrapper": "Testimonials-module__7XlpBa__testimonialsWrapper",
});
